// import CardContainer from "../components/CardContainer.js";

// export default function Home() {
//     return (
//         <>
//             <h1>Welcome to ZBSPORTS</h1>
//             {/* <CardContainer /> */}
//         </>
//     )
// }

import Card from 'react-bootstrap/Card';  
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom'; // import for navigation


// array defines a list of team names used for display.
const names = ["Atlanta Hawks", "Boston Celtics", "Brooklyn Nets", "Charlotte Hornets", "Chicago Bulls", "Clevland Cavaliers", "Dallas Mavericks","Denver Nuggets", "Detroit Pistons",
 "Golden State Warriors", "Houston Rockets", "Indiana Pacers", "Los Angeles Clippers", "Los Angeles Lakers", "Memphis Grizzlies", "Miami Heat", "Milwaukee Bucks", "Minnesota Timberwolves", "New Orleans Pelicans", "New York Knicks", "Oklahoma City Thunder", "Orlando Magic", "Philadelphia 76ers", "Phoenix Suns",
 "Portland Trail Blazers", "Sacramento Kings", "San Antonio Spurs", "Toronto Raptors", "Utah Jazz", "Washington Wizards"
]

// function defines the React component that displays the team cards grid.

// defines a Row component with two responsive breakpoints:  
// xs={1} displays one card per row on extra small devices (like mobile phones).md={4} displays four cards per row on medium and larger devices. bg-sky-400 class for background color styling.


// Array.from({ length: 30 } :  creates an array of length 30 using the Array.from method. This allows us to loop and generate cards even if we don't have actual data yet.

// .map((team,:  goes through the array of 30 items and creates a card for each one using the map function.  Team and idx are variables used within the callback function.

// Link to= : creates a Link component that navigates to the /teamInfo route. The to prop specifies the route path with a query parameter teamId set to the current index + 132 (offset for actual team IDs). Adds a class teamCards for styling.

// <Col key={idx}>:   creates a Col component to manage the responsive grid layout. Sets the key prop to the current index for efficient rendering updates.

// <Card ...>:   creates a Card component to represent each team.Adds additional properties to customize the card appearance:      className: for styling   and  variant: "top" for image placement

// <Card.Body>:  This line defines the card body where the title and text will be displayed.

// <Card.Title>{names : shows the team name using the Card.Title component and accesses the corresponding name from the names array based on the current index.

// displays any additional information about the team within the Card.Text component.

// /Card.Body> and </Card>:  close the card body and card components.




function GridExample() {
  
  return (
    <Row xs={1} md={4} className="bg-gray-200" >
      {Array.from({ length: 30 }).map((team, idx) => (
        <Link to={`/teamInfo?teamId=${idx+132}`} className='teamCards'  key={idx} >
        <Col key={idx}>
          <Card  className=''>
            <Card.Img variant="top" src={`https://media-4.api-sports.io/basketball/teams/${idx+132}.png`} 
            style={{ width: '20%', height: '20%', objectFit: 'cover' , display:'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '25px', marginBottom: 'auto'  }}/>
            <Card.Body>
              <Card.Title>{names[idx]}</Card.Title>
              <Card.Text>
                
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        </Link>
      ))}
    </Row>
  );
}

export default GridExample;
